/* eslint-disable camelcase */

/**
 * @description 业务上报 蜂巢
 */

import { getCookie } from './util';
import { detect } from '@iv/shared/src/detect';

export enum ReportType {
  expose = 'expose',
  click = 'click',
  pageView = 'pageView',
}

// atta上报基础数据
const baseAttaReportData = {
  os_type: '',
  omgid: getCookie('video_omgid'),
  vuserid: getCookie('vuserid') || getCookie('vqq_vuserid'),
  main_login: getCookie('main_login'),
  uin: getCookie('uin'),
  wx_openid: getCookie('openid') || getCookie('vqq_openid'),
  UA: navigator.userAgent,
};

export const detectAttaOsType = (userAgent?: string) => {
  const { osType, appType, deviceType, isMobile } = detect(userAgent);

  if (appType === 'unknown') {
    baseAttaReportData.os_type = osType;
    return;
  }

  if (appType !== 'tenvideo') {
    baseAttaReportData.os_type = appType;
    return;
  }

  if (/ipad|apad/.test(deviceType)) {
    baseAttaReportData.os_type = deviceType;
    return;
  }

  if (osType === 'android') {
    baseAttaReportData.os_type = isMobile ? '1100214736' : 'apad';
    return;
  }

  baseAttaReportData.os_type = '1200010169';
};

detectAttaOsType();

// atta上报数据
interface attaReportData {
  appid?: string | number;
  cid?: string;
  vid?: string;
  sub_rtype?: string | number;
  chapter_id?: string | number;
  branch_id?: string | number;
  ptag?: string | number;
  reportkey?: string | number;
  data_type?: string | number;
  mod_id?: string | number;
  sub_mod_id?: string | number;
  rtype?: string | number;
  third_mod_id?: string | number;
  pageid?: string | number;
}

// 发送上报请求
export const attaId = '03400074989';
const reportAtta = (data: any) => {
  const query = Object.keys(data)
    .map(key => `${key}=${
      data[key] !== null && typeof data[key] !== 'undefined'
        ? encodeURIComponent(data[key])
        : ''
    }`)
    .join('&');
  const dc = Math.random();
  const url = `https://h.trace.qq.com/kv?attaid=${attaId}&token=5425552161&${query}&_dc=${dc}`;
  const image = new Image();
  image.src = url;
};

// atta公共上报参数
const getCommonAttaReportData = (param: attaReportData) => {
  const {
    appid = '',
    cid = '',
    vid = '',
    ptag = '',
  } = param;
  return {
    activity_id: appid,
    cid,
    vid,
    sub_rtype: param.sub_rtype,
    chapter_id: param.chapter_id,
    branch_id: param.branch_id,
    ptag,
  };
};

// 曝光
export const attaExpose = (param: attaReportData) => {
  const { reportkey = '', rtype = '' } = param;
  const data = {
    reportkey,
    data_type: param.data_type || '',
    mod_id: param.mod_id || '',
    sub_mod_id: param.sub_mod_id || '',
    third_mod_id: param.third_mod_id || '',
    rtype,
  };
  reportAtta({
    ...getCommonAttaReportData(param),
    ...data,
    ...baseAttaReportData,
    report_type: ReportType.expose,
  });
};

// 点击
export const attaClick = (param: attaReportData) => {
  const {
    reportkey = '',
    rtype = '',
  } = param;
  const data = {
    reportkey,
    data_type: param.data_type || '',
    mod_id: param.mod_id || '',
    sub_mod_id: param.sub_mod_id || '',
    third_mod_id: param.third_mod_id || '',
    rtype,
  };
  reportAtta({
    ...getCommonAttaReportData(param),
    ...data,
    ...baseAttaReportData,
    report_type: ReportType.click,
  });
};

// pv
export const attaPageView = (param: attaReportData) => {
  const { pageid } = param;
  const data = {
    pageid: pageid || '',
  };
  reportAtta({
    ...getCommonAttaReportData(param),
    ...data,
    ...baseAttaReportData,
    report_type: ReportType.pageView,
  });
};
